/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Case_Doc_Tow_ReceiptsInputs */

const en_case_doc_tow_receipts = /** @type {(inputs: Case_Doc_Tow_ReceiptsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tow and rental receipts/invoices`)
};

const pt_br2_case_doc_tow_receipts = /** @type {(inputs: Case_Doc_Tow_ReceiptsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Notas fiscais/recibos de guincho, locação de carro`)
};

/**
* | output |
* | --- |
* | "Tow and rental receipts/invoices" |
*
* @param {Case_Doc_Tow_ReceiptsInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const case_doc_tow_receipts = /** @type {((inputs?: Case_Doc_Tow_ReceiptsInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Case_Doc_Tow_ReceiptsInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_case_doc_tow_receipts(inputs)
	return pt_br2_case_doc_tow_receipts(inputs)
});